import HttpClient from "./HttpClient";

class AccountsRepository {
  private http = HttpClient.getInstance();

  async accounts(authBasic: string): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.get(
          "/api/v1/documents/associates/accounts",
          {
            headers: {
              Authorization: `Basic ${authBasic}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
        resolve(response);
      } catch (error) {
        console.error("Error al iniciar sesión:", error);
        reject(error);
      }
    });
  }
  async getSocioAccounts(authBasic: string): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.get(
          "/api/v1/documents/associates/socio_accounts",
          {
            headers: {
              Authorization: `Basic ${authBasic}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
        resolve(response);
      } catch (error) {
        console.error("Error al obtener las cuentas del socio:", error);
        reject(error);
      }
    });
  }
}
export default new AccountsRepository();
